// import React from "react";
// import ReactApexChart from "react-apexcharts";
// import { Box, Grid, Typography, Card } from "@mui/material";

// const TopProductsCharts = () => {
//   const quantityChart = {
//     labels: [
//       "Contraband Hands Off Eau De Parfum Leathery Ambery Fragrance With Hazelnut Oud & Vanila",
//       "shampoo",
//       "Hair growth serum",
//       "D'Acne Body & Face Soap",
//       "Lipstick"
//     ],
//     data: [121, 97, 92, 66, 58]
//   };

//   const revenueChart = {
//     labels: [
//       "Hair growth serum",
//       "Contraband Hands Off Eau De Parfum Leathery Ambery Fragrance With Hazelnut Oud & Vanila",
//       "shampoo",
//       "Lipstick",
//       "shaving foam"
//     ],
//     data: [31464, 20194, 15714, 7830, 6480]
//   };

//   const baseBarOptions = {
//     chart: {
//       type: "bar",
//       toolbar: { show: false },
//       animations: { enabled: true, easing: "easeinout", speed: 800 }
//     },
//     plotOptions: {
//       bar: {
//         borderRadius: 8,
//         horizontal: true,
//         distributed: true,
//         barHeight: "65%"
//       }
//     },
//     grid: {
//       borderColor: "rgba(0,0,0,0.1)",
//       strokeDashArray: 3
//     },
//     tooltip: {
//       theme: "dark",
//       y: {
//         formatter: val => val.toLocaleString()
//       }
//     },
//     legend: { show: false },
//     dataLabels: {
//       enabled: true,
//       style: {
//         fontSize: "12px",
//         fontWeight: "bold",
//         colors: ["#fff"]
//       },
//       dropShadow: { enabled: true }
//     },
//     colors: ["#6C63FF", "#00BFA6", "#FF6F61", "#F9A826", "#3F51B5", "#E91E63"],
//     xaxis: {
//       labels: {
//         style: { fontSize: "12px" }
//       }
//     },
//     yaxis: {
//       labels: {
//         style: {
//           fontSize: "12px",
//           fontWeight: 500,
//           whiteSpace: "normal"
//         }
//       }
//     }
//   };

//   const quantityOptions = {
//     ...baseBarOptions,
//     title: {
//       text: "Top 5 Products by Quantity Sold",
//       align: "center",
//       style: { fontWeight: 600, fontSize: "16px" }
//     },
//     xaxis: { ...baseBarOptions.xaxis, categories: quantityChart.labels },
//     dataLabels: {
//       ...baseBarOptions.dataLabels,
//       formatter: val => `${val} units`
//     }
//   };

//   const revenueOptions = {
//     ...baseBarOptions,
//     title: {
//       text: "Top 5 Products by Revenue (₹)",
//       align: "center",
//       style: { fontWeight: 600, fontSize: "16px" }
//     },
//     xaxis: { ...baseBarOptions.xaxis, categories: revenueChart.labels },
//     dataLabels: {
//       ...baseBarOptions.dataLabels,
//       formatter: val => `₹${val.toLocaleString()}`
//     }
//   };

//   return (
//     <Box>
//       <Typography
//         variant="h5"
//         sx={{
//           mb: 4,
//           fontWeight: 700,
//           textAlign: "center",
//           color: "text.primary",
//           fontFamily: "Mulish, sans-serif",
//           mt: 4
//         }}
//       >
//         Product Performance Dashboard
//       </Typography>

//       <Grid container spacing={3}>
//         <Grid item xs={12} md={6}>
//           <Card
//             sx={{
//               p: 2,
//               borderRadius: 4,
//               boxShadow: 3,
//               bgcolor: "background.paper"
//             }}
//           >
//             <ReactApexChart
//               options={quantityOptions}
//               series={[{ name: "Units Sold", data: quantityChart.data }]}
//               type="bar"
//               height={380}
//             />
//           </Card>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <Card
//             sx={{
//               p: 2,
//               borderRadius: 4,
//               boxShadow: 3,
//               bgcolor: "background.paper"
//             }}
//           >
//             <ReactApexChart
//               options={revenueOptions}
//               series={[{ name: "Revenue (₹)", data: revenueChart.data }]}
//               type="bar"
//               height={380}
//             />
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default TopProductsCharts;

import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
  Box,
  Grid,
  Typography,
  Card,
  CircularProgress,
  Alert
} from "@mui/material";
import { getData } from "../Webservice/Webservice";

const TopProductsCharts = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/chart/top-selling", null, token);

        if (data && data.success && data.charts) {
          setChartData(data);
        } else {
          throw new Error("Invalid chart data response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load top products chart data");
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box sx={{ my: 4 }}>
        <Alert severity="error">
          {error}
        </Alert>
      </Box>
    );
  }

  // Show chart when data is available
  if (!chartData) {
    return null;
  }

  const { quantityChart, revenueChart } = chartData.charts;

  const baseBarOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      animations: { enabled: true, easing: "easeinout", speed: 800 }
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        distributed: true,
        barHeight: "65%"
      }
    },
    grid: {
      borderColor: "rgba(0,0,0,0.1)",
      strokeDashArray: 3
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: val => val.toLocaleString()
      }
    },
    legend: { show: false },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#fff"]
      },
      dropShadow: { enabled: true }
    },
    colors: ["#6C63FF", "#00BFA6", "#FF6F61", "#F9A826", "#3F51B5", "#E91E63"],
    xaxis: {
      labels: {
        style: { fontSize: "12px" }
      }
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 500,
          whiteSpace: "normal"
        }
      }
    }
  };

  const quantityOptions = {
    ...baseBarOptions,
    title: {
      text: "Top 5 Products by Quantity Sold",
      align: "center",
      style: { fontWeight: 600, fontSize: "16px" }
    },
    xaxis: {
      ...baseBarOptions.xaxis,
      categories: quantityChart.labels.map(
        label => (label.length > 50 ? label.substring(0, 50) + "..." : label)
      )
    },
    dataLabels: {
      ...baseBarOptions.dataLabels,
      formatter: val => `${val} units`
    },
    tooltip: {
      ...baseBarOptions.tooltip,
      y: {
        formatter: val => `${val} units`
      }
    }
  };

  const revenueOptions = {
    ...baseBarOptions,
    title: {
      text: "Top 5 Products by Revenue (₹)",
      align: "center",
      style: { fontWeight: 600, fontSize: "16px" }
    },
    xaxis: {
      ...baseBarOptions.xaxis,
      categories: revenueChart.labels.map(
        label => (label.length > 50 ? label.substring(0, 50) + "..." : label)
      )
    },
    dataLabels: {
      ...baseBarOptions.dataLabels,
      formatter: val => `₹${val.toLocaleString()}`
    },
    tooltip: {
      ...baseBarOptions.tooltip,
      y: {
        formatter: val => `₹${val.toLocaleString()}`
      }
    }
  };

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: 700,
          textAlign: "center",
          color: "text.primary",
          fontFamily: "Mulish, sans-serif",
          mt: 4
        }}
      >
        Product Performance Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 2,
              borderRadius: 4,
              boxShadow: 3,
              bgcolor: "background.paper"
            }}
          >
            <ReactApexChart
              options={quantityOptions}
              series={[
                {
                  name: quantityChart.datasets[0].label,
                  data: quantityChart.datasets[0].data
                }
              ]}
              type="bar"
              height={380}
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 2,
              borderRadius: 4,
              boxShadow: 3,
              bgcolor: "background.paper"
            }}
          >
            <ReactApexChart
              options={revenueOptions}
              series={[
                {
                  name: revenueChart.datasets[0].label,
                  data: revenueChart.datasets[0].data
                }
              ]}
              type="bar"
              height={380}
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopProductsCharts;
